import { useState } from 'react';
import { stringToHsl } from '@s20/common/util/style';

export const Logo = ({ src, alt, ...restProps }) => {
    const [hasError, setHasError] = useState(false);

    if (hasError) {
        const color = stringToHsl(alt);

        return (
            <div
                className="tenant-logo mr-2 flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center"
                style={{
                    backgroundColor: color,
                }}
            >
                <span className="text-white">
                    {Boolean(alt) && alt.charAt(0)}
                </span>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            {...restProps}
            className="tenant-logo mr-2 flex-shrink-0"
            onError={() => {
                setHasError(true);
            }}
        />
    );
};